import React, { useState } from 'react';
import { Activity, Filter, Search, Calendar, User, Building2, HandshakeIcon, Mail, Phone, FileText, CheckCircle, Clock, AlertCircle, TrendingUp, Users } from 'lucide-react';
const activityTypes = [{
  id: 'all',
  label: 'Tutte',
  icon: Activity
}, {
  id: 'deal',
  label: 'Trattative',
  icon: HandshakeIcon
}, {
  id: 'meeting',
  label: 'Incontri',
  icon: Users
}, {
  id: 'call',
  label: 'Chiamate',
  icon: Phone
}, {
  id: 'email',
  label: 'Email',
  icon: Mail
}, {
  id: 'property',
  label: 'Immobili',
  icon: Building2
}, {
  id: 'document',
  label: 'Documenti',
  icon: FileText
}];
const activities = [{
  id: 1,
  type: 'deal',
  member: 'Marco Rossi',
  memberAvatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  action: 'ha chiuso una trattativa',
  title: 'Negozio Via Montenapoleone',
  description: 'Contratto firmato con Luxury Fashion Brand per €85.000',
  timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
  status: 'completed',
  priority: 'high'
}, {
  id: 2,
  type: 'meeting',
  member: 'Laura Bianchi',
  memberAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
  action: 'ha completato un incontro',
  title: 'Presentazione Boutique Corso Como',
  description: 'Incontro con il team di Prada per discutere i dettagli',
  timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
  status: 'completed',
  priority: 'medium'
}, {
  id: 3,
  type: 'call',
  member: 'Giuseppe Verdi',
  memberAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
  action: 'ha effettuato una chiamata',
  title: 'Follow-up Designer Boutique',
  description: 'Discussione su modifiche contrattuali richieste',
  timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000),
  status: 'completed',
  priority: 'low'
}, {
  id: 4,
  type: 'email',
  member: 'Sofia Romano',
  memberAvatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  action: 'ha inviato una proposta',
  title: 'Proposta Store Via della Spiga',
  description: 'Inviata proposta commerciale a Versace',
  timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
  status: 'pending',
  priority: 'high'
}, {
  id: 5,
  type: 'property',
  member: 'Andrea Ferrari',
  memberAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  action: 'ha aggiunto un immobile',
  title: 'Showroom Brera',
  description: 'Nuovo immobile di 180m² aggiunto al portfolio',
  timestamp: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000),
  status: 'completed',
  priority: 'medium'
}, {
  id: 6,
  type: 'deal',
  member: 'Marco Rossi',
  memberAvatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop',
  action: 'ha avviato una trattativa',
  title: 'Negozio Corso Venezia',
  description: 'Nuova opportunità con Armani per flagship store',
  timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
  status: 'in_progress',
  priority: 'high'
}, {
  id: 7,
  type: 'document',
  member: 'Laura Bianchi',
  memberAvatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
  action: 'ha caricato un documento',
  title: 'Contratto Boutique Milano',
  description: 'Contratto preliminare caricato e inviato per revisione',
  timestamp: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
  status: 'pending',
  priority: 'medium'
}, {
  id: 8,
  type: 'meeting',
  member: 'Giuseppe Verdi',
  memberAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop',
  action: 'ha programmato un incontro',
  title: 'Visita Store Quadrilatero',
  description: 'Sopralluogo programmato per domani alle 15:00',
  timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
  status: 'scheduled',
  priority: 'medium'
}, {
  id: 9,
  type: 'call',
  member: 'Sofia Romano',
  memberAvatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
  action: 'ha effettuato una chiamata',
  title: 'Negoziazione Affitto',
  description: 'Discussione su termini contrattuali con proprietario',
  timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
  status: 'completed',
  priority: 'high'
}, {
  id: 10,
  type: 'email',
  member: 'Andrea Ferrari',
  memberAvatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
  action: 'ha inviato un follow-up',
  title: 'Reminder Documentazione',
  description: 'Richiesta documenti mancanti a brand interessato',
  timestamp: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
  status: 'pending',
  priority: 'low'
}];
export function TeamActivities() {
  const [selectedType, setSelectedType] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedMember, setSelectedMember] = useState<string | null>(null);
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'deal':
        return HandshakeIcon;
      case 'meeting':
        return Users;
      case 'call':
        return Phone;
      case 'email':
        return Mail;
      case 'property':
        return Building2;
      case 'document':
        return FileText;
      default:
        return Activity;
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-700';
      case 'in_progress':
        return 'bg-blue-100 text-blue-700';
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      case 'scheduled':
        return 'bg-purple-100 text-purple-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'completed':
        return 'Completato';
      case 'in_progress':
        return 'In corso';
      case 'pending':
        return 'In attesa';
      case 'scheduled':
        return 'Programmato';
      default:
        return status;
    }
  };
  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'high':
        return 'border-l-red-500';
      case 'medium':
        return 'border-l-yellow-500';
      case 'low':
        return 'border-l-green-500';
      default:
        return 'border-l-gray-300';
    }
  };
  const formatTimestamp = (date: Date) => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    if (diffHours < 1) {
      const diffMins = Math.floor(diffMs / (1000 * 60));
      return `${diffMins} minuti fa`;
    } else if (diffHours < 24) {
      return `${diffHours} ore fa`;
    } else if (diffDays === 1) {
      return 'Ieri';
    } else if (diffDays < 7) {
      return `${diffDays} giorni fa`;
    } else {
      return date.toLocaleDateString('it-IT', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    }
  };
  const filteredActivities = activities.filter(activity => {
    const matchesType = selectedType === 'all' || activity.type === selectedType;
    const matchesSearch = searchQuery === '' || activity.title.toLowerCase().includes(searchQuery.toLowerCase()) || activity.description.toLowerCase().includes(searchQuery.toLowerCase()) || activity.member.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesMember = !selectedMember || activity.member === selectedMember;
    return matchesType && matchesSearch && matchesMember;
  });
  const uniqueMembers = Array.from(new Set(activities.map(a => a.member))).sort();
  const activityStats = {
    total: activities.length,
    completed: activities.filter(a => a.status === 'completed').length,
    pending: activities.filter(a => a.status === 'pending').length,
    inProgress: activities.filter(a => a.status === 'in_progress').length
  };
  return <div className="space-y-6" data-id="element-2899">
      <div data-id="element-2900">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2901">
          Attività del Team
        </h1>
        <p className="text-sm text-gray-500 mt-1" data-id="element-2902">
          Monitora tutte le attività e le azioni del team
        </p>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2903">
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-2904">
          <div className="flex items-center justify-between mb-2" data-id="element-2905">
            <span className="text-sm text-gray-500" data-id="element-2906">Totale Attività</span>
            <Activity className="w-4 h-4 text-[#1388ad]" data-id="element-2907" />
          </div>
          <p className="text-2xl font-semibold text-gray-900" data-id="element-2908">
            {activityStats.total}
          </p>
        </div>
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-2909">
          <div className="flex items-center justify-between mb-2" data-id="element-2910">
            <span className="text-sm text-gray-500" data-id="element-2911">Completate</span>
            <CheckCircle className="w-4 h-4 text-green-500" data-id="element-2912" />
          </div>
          <p className="text-2xl font-semibold text-gray-900" data-id="element-2913">
            {activityStats.completed}
          </p>
        </div>
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-2914">
          <div className="flex items-center justify-between mb-2" data-id="element-2915">
            <span className="text-sm text-gray-500" data-id="element-2916">In Corso</span>
            <Clock className="w-4 h-4 text-blue-500" data-id="element-2917" />
          </div>
          <p className="text-2xl font-semibold text-gray-900" data-id="element-2918">
            {activityStats.inProgress}
          </p>
        </div>
        <div className="bg-white border border-gray-200 p-6 rounded-lg" data-id="element-2919">
          <div className="flex items-center justify-between mb-2" data-id="element-2920">
            <span className="text-sm text-gray-500" data-id="element-2921">In Attesa</span>
            <AlertCircle className="w-4 h-4 text-yellow-500" data-id="element-2922" />
          </div>
          <p className="text-2xl font-semibold text-gray-900" data-id="element-2923">
            {activityStats.pending}
          </p>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2924">
        <div className="flex flex-col lg:flex-row gap-4" data-id="element-2925">
          {/* Search */}
          <div className="flex-1" data-id="element-2926">
            <div className="relative" data-id="element-2927">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-2928" />
              <input type="text" placeholder="Cerca attività..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] text-sm" data-id="element-2929" />
            </div>
          </div>
          {/* Member Filter */}
          <select value={selectedMember || ''} onChange={e => setSelectedMember(e.target.value || null)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1388ad] text-sm bg-white" data-id="element-2930">
            <option value="" data-id="element-2931">Tutti i membri</option>
            {uniqueMembers.map(member => <option key={member} value={member} data-id="element-2932">
                {member}
              </option>)}
          </select>
          {/* Type Filters */}
          <div className="flex gap-2 overflow-x-auto pb-2 lg:pb-0" data-id="element-2933">
            {activityTypes.map(type => {
            const Icon = type.icon;
            return <button key={type.id} onClick={() => setSelectedType(type.id)} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${selectedType === type.id ? 'bg-[#1388ad] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2934">
                  <Icon className="w-4 h-4" data-id="element-2935" />
                  {type.label}
                </button>;
          })}
          </div>
        </div>
      </div>
      {/* Activities List */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2936">
        <div className="divide-y divide-gray-200" data-id="element-2937">
          {filteredActivities.length === 0 ? <div className="p-12 text-center" data-id="element-2938">
              <Activity className="w-12 h-12 text-gray-400 mx-auto mb-4" data-id="element-2939" />
              <p className="text-gray-500" data-id="element-2940">Nessuna attività trovata</p>
            </div> : filteredActivities.map(activity => {
          const Icon = getActivityIcon(activity.type);
          return <div key={activity.id} className={`p-6 hover:bg-gray-50 transition-colors border-l-4 ${getPriorityColor(activity.priority)}`} data-id="element-2941">
                  <div className="flex items-start gap-4" data-id="element-2942">
                    <div className="w-10 h-10 bg-[#1388ad]/10 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-2943">
                      <Icon className="w-5 h-5 text-[#1388ad]" data-id="element-2944" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-2945">
                      <div className="flex items-start justify-between gap-4 mb-2" data-id="element-2946">
                        <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-2947">
                          <img src={activity.memberAvatar} alt={activity.member} className="w-8 h-8 rounded-full object-cover flex-shrink-0" data-id="element-2948" />
                          <div className="flex-1 min-w-0" data-id="element-2949">
                            <p className="text-sm text-gray-900" data-id="element-2950">
                              <span className="font-semibold" data-id="element-2951">
                                {activity.member}
                              </span>{' '}
                              {activity.action}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-2952">
                              {formatTimestamp(activity.timestamp)}
                            </p>
                          </div>
                        </div>
                        <span className={`px-3 py-1 text-xs font-medium rounded-full ${getStatusColor(activity.status)}`} data-id="element-2953">
                          {getStatusLabel(activity.status)}
                        </span>
                      </div>
                      <div className="ml-11" data-id="element-2954">
                        <h4 className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2955">
                          {activity.title}
                        </h4>
                        <p className="text-sm text-gray-600" data-id="element-2956">
                          {activity.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>;
        })}
        </div>
      </div>
    </div>;
}